<template>
  <div v-loading="showFlag">
    <!--  支払入荷選択画面 -->
    <t-card>
      <div :style="{ height: basicHeight + 'px' }">
        <t-form
          :model="searchConditionForm"
          label-position="right"
          label-width="100px"
        >
          <t-row type="flex" justify="center">
            <!-- 仕入先 -->
            <t-col :span="5">
              <t-form-item
                :label="$t('resource.orderInfo.supplierCpy')"
                class="marginBottom"
              >
                <t-select
                  v-model="searchConditionForm.searchSupCode"
                  class="commonDialog"
                  disabled
                >
                  <t-option
                    v-for="item in supCodeList"
                    :key="item.supCode"
                    :label="item.supCode + ':' + item.supAbbreviation"
                    :value="item.supCode"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col>
            <!-- 運送No -->
            <t-col :span="5">
              <t-form-item
                :label="$t('resource.CUSTOMER_PAY.TRANSPORT_NO')"
                class="marginBottom"
              >
                <t-input
                  v-model="searchConditionForm.searchTransNo"
                  class="commonDialog"
                  maxLength="20"
                  clearable
                >
                </t-input>
              </t-form-item>
            </t-col>

            <!-- 入荷日 -->
            <t-col :span="10" class="marginBottom">
              <div>
                <t-form-item
                  :label="$t('resource.CUSTOMER_PAY.RECEIVE_DATE')"
                  class="marginBottom"
                >
                  <t-date-picker
                    class="date_icon_center"
                    v-model="dateRange"
                    type="daterange"
                    range-separator="～"
                    start-placeholder="開始日"
                    end-placeholder="終了日"
                    value-format="yyyy/MM/dd"
                    format="yyyy/MM/dd"
                    :editable="false"
                    style="margin-top: 3px"
                    :clearable="false"
                  >
                  </t-date-picker>
                </t-form-item>
              </div>
            </t-col>

            <t-col :span="3">
              <!-- 検索 -->
              <t-button
                round
                type="primary"
                class="dialogButton_120_40"
                ref="searchBtn"
                @click="searchClick()"
              >
                <i class="el-icon-search"></i>
                {{ $t("resource.sys.search") }}
              </t-button>
            </t-col>
          </t-row>
        </t-form>
      </div>

      <div>
        <t-row class="marginBottom">
          <t-col :span="1"> &nbsp;</t-col>
          <t-col :span="22">
            <!-- テーブル -->
            <div>
              <t-table
                ref="jpRevSelectTable"
                :data="jpRevSelectTable"
                class="table_common"
                header-cell-class-name="bg-default"
                :height="detailHeight"
                highlight-current-row
                :cell-class-name="TableCellClassName"
                @row-click="handleRowClick"
                border
                fit
              >
                <!-- 選択ボックス -->
                <t-table-column type="selection" class-name="cell_txt_center" />
                <!-- テーブルの列 -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                </t-table-column>
              </t-table>
            </div>
          </t-col>
          <t-col :span="1"> &nbsp;</t-col>
        </t-row>
      </div>
      <div :style="{ height: bottomHeight + 'px' }">
        <t-form label-position="right">
          <t-row>
            <div>
              <t-col
                :span="
                  parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_TWENTY_THREE'))
                "
                class="right"
              >
                <t-button
                  round
                  type="warning"
                  class="dialogButton_confirm_120_40"
                  ref="confirmBtn"
                  @click="confirmClick"
                >
                  <i class="el-icon-check"></i>
                  {{ $t("resource.sys.sure") }}</t-button
                >
              </t-col>
              <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
                >&nbsp;</t-col
              >
            </div>
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { t } from "@/locales";
import {
  initCustPaySearchList,
  searchJpReceSelectForm,
} from "@/services/customerPayInfo";
import {
  formatCurDateToString,
  formatDateToString,
  formatUndefinedToDate,
  getDialogContentHeight,
  getPreviousMonthDate,
} from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT, MSM_DL_KBN, STR_COLON, STR_EMPTY } from "@/utils/const";
import { flexColumnWidth, setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      dateRange: [],
      //検索条件
      searchConditionForm: {
        searchSupCode: "", // 仕入先
        searchTransNo: "", // 運送No
        searchStartDate: "", //入荷日(開始日)
        searchEndDate: "", //入荷日(終了日)
      },
      //仕入先リスト
      supCodeList: [],

      //入荷選択テーブル
      jpRevSelectTable: [],
      //入荷選択依頼のテーブルの列
      columns: [
        // 仕入先
        {
          prop: "pbSupCodeShow",
          label: t("resource.CUSTOMER_PAY.SUPPLIER_COMPANY"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },
        {
          // 日本入荷日
          prop: "jrbReceDate",
          label: t("resource.CUSTOMER_PAY.OFFICER_RECEIVE_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },

        // 運送No
        {
          prop: "jrbTransOrderNo",
          label: t("resource.CUSTOMER_PAY.TRANSPORT_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        //入荷No.
        {
          prop: "pdReceNo",
          label: t("resource.CUSTOMER_PAY.JP_RECE_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
      ],
      //入荷選択情報
      selectedProcForm: [],
      //true:見積依頼書出力ボタンをクリックできない  false:見積依頼書出力ボタンをクリックできる
      buttonClickFlag: true,
      //追加された「仕入先」列の番号
      newColumnNo: 0,
      //現在選択されているセル
      currentCell: null,
      showFlag: false,

      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT * 1,
      //明細情報のheight 20:Tableと合計行の間隔調整用(Table的marginTop + bottom)
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 1,
        20
      ),
      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,

      // 読み込み回数
      numLoads: 1,

      // 比較用明細情報
      cmpDetailResult: "",
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    tableData: {
      Type: Object,
      default: null,
    },
    pbSupCode: {
      Type: Object,
      default: null,
    },
    selectSearchForm: {
      Type: Object,
      default: null,
    },
    pbPayNo: {
      Type: Object,
      default: null,
    },
  },
  mounted() {
    this.Init();
    setColumnWidth(this.columns, this.jpRevSelectTable);
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 1,
        20
      );
    },

    // 初期化
    Init() {
      this.showFlag = true;

      //検索条件リストの初期化(状態、支払状態)
      initCustPaySearchList()
        .then((res) => {
          //仕入先リストに追加
          this.supCodeList = res.supInfoList;

          //検索条件が空しない場合
          if (!!this.selectSearchForm && this.selectSearchForm != STR_EMPTY) {
            this.searchConditionForm = [];
            this.searchConditionForm = this.selectSearchForm;

            // ADD 2025/02/26 ZLL 課題_納品請求予定日の検討 start↓
            if (
              this.selectSearchForm.searchSupCode !=
              this.pbSupCode.split(STR_COLON)[0]
            ) {
              this.searchConditionForm.searchSupCode =
                this.pbSupCode.split(STR_COLON)[0];
            }
            // ADD 2025/02/26 ZLL 課題_納品請求予定日の検討 end↑

            if (this.searchConditionForm.searchStartDate == STR_EMPTY) {
              this.dateRange = [];
            } else {
              this.dateRange = [
                formatUndefinedToDate(this.searchConditionForm.searchStartDate),
                formatUndefinedToDate(this.searchConditionForm.searchEndDate),
              ];
            }
          } else {
            //日付初期化
            this.dateInit();
            if (!!this.pbSupCode) {
              this.searchConditionForm.searchSupCode =
                this.pbSupCode.split(STR_COLON)[0];
            } else {
              this.searchConditionForm.searchSupCode =
                this.supCodeList[0]?.supCode;
            }
          }
          this.searchClick();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        });
    },

    dateInit() {
      //システム日付
      var systemDate = new Date();
      //日付初期値の設定
      this.dateRange = [getPreviousMonthDate(systemDate), systemDate];
      if (!!this.tableData) {
        //運送明細テーブル入荷日
        for (let index = 0; index < this.tableData.length; index++) {
          const element = this.tableData[index];

          var jrbReceDate = formatUndefinedToDate(element.jrbReceDate);

          if (jrbReceDate > this.dateRange[1]) {
            this.dateRange[1] = jrbReceDate;
          }
          if (jrbReceDate < this.dateRange[0]) {
            this.dateRange[0] = jrbReceDate;
          }
        }
      }
    },

    // 検索
    searchClick() {
      if (!this.showFlag) {
        this.showFlag = true;
      }
      //検索条件の処理
      this.updateSearchForm();

      searchJpReceSelectForm({
        jpReceSelectSearchInfo: this.searchConditionForm,
        payNo: this.pbPayNo,
      })
        .then((res) => {
          this.jpRevSelectTable = res.customerPayDetailInfoList;

          // データ処理
          this.dataProcess();
          this.checkedProcess();
          //列幅の設定
          setColumnWidth(this.columns, this.jpRevSelectTable);

          // 読み込み回数 = 1
          if (this.numLoads == 1) {
            this.$nextTick(() => {
              let data = this.$refs.jpRevSelectTable.selection;

              // 比較用明細情報
              this.cmpDetailResult = JSON.parse(JSON.stringify(data));
            });

            // 読み込み回数 + 1
            this.numLoads = this.numLoads + 1;
          }

          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })

        .finally(() => {
          this.showFlag = false;
        });
      // フォーカス削除
      this.$refs.searchBtn.$el.blur();
    },

    // データ処理
    dataProcess() {
      this.jpRevSelectTable.map((item) => {
        //日本入荷日が空のチェック
        item.jrbReceDate = formatCurDateToString(item.jrbReceDate);
        return item;
      });
    },

    //チェックボックスの選択処理
    checkedProcess() {
      if (!!this.tableData) {
        this.tableData.forEach((row) => {
          for (let index = 0; index < this.jpRevSelectTable.length; index++) {
            const element = this.jpRevSelectTable[index];

            //詳細画面選択のデータ選択チェックボックス
            // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
            // 現象：ミスミデータ作成に失敗しました。ミスミ大連のデータは取得の場合、検査室入荷データと日本入荷データは区別されていない
            // if (
            //   row.pdReceNo == element.pdReceNo &&
            //   this.pbSupCode == element.pbSupCodeShow
            // ) {

            const baseCondition = row.pdReceNo == element.pdReceNo &&
              this.pbSupCode == element.pbSupCodeShow;
            const hasFive = row.aodMisumiKbn == MSM_DL_KBN || element.aodMisumiKbn == MSM_DL_KBN;

             if (baseCondition && (!hasFive || row.aodMisumiKbn == element.aodMisumiKbn)) {
              // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
              this.$nextTick(() => {
                this.$refs.jpRevSelectTable.toggleRowSelection(
                  this.jpRevSelectTable[index],
                  true
                );
              });
            } else {
              continue;
            }
          }
        });
      }
    },

    updateSearchForm() {
      if (!!this.searchConditionForm.searchSupCode) {
        this.searchConditionForm.searchSupCode =
          this.searchConditionForm.searchSupCode.split(":")[0];
      }

      if (this.dateRange) {
        //入荷日(開始)
        this.searchConditionForm.searchStartDate = formatDateToString(
          this.dateRange[0]
        );
        //入荷日(終了)
        this.searchConditionForm.searchEndDate = formatDateToString(
          this.dateRange[1]
        );
      } else {
        this.searchConditionForm.searchStartDate = "";
        this.searchConditionForm.searchEndDate = "";
      }
    },

    //确定ボタン
    confirmClick() {
      let data = this.$refs.jpRevSelectTable.selection;
      if (!!data && data.length > 0) {
        this.selectedProcForm = this.selectDataProcess(data);

        //同じ仕入先の検査
        if (!this.cusCodeCheck(data)) {
          Modal.showWarning("", t("message.CUS_PAY.SELECT_CUS_CODE_CHECK"), {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return;
        } else {
          var result = [
            { key: "selectedProcForm", value: this.selectedProcForm },
            { key: "selectSearchForm", value: this.searchConditionForm },
          ];
          this.$emit("ok", result);
          // });
        }
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }

      if (typeof this.$refs.confirmBtn !== "undefined") {
        // フォーカス削除
        this.$refs.confirmBtn.$el.blur();
      }
    },

    //同じ仕入先の検査
    cusCodeCheck() {
      const uniqueSupCodes = new Set(
        this.selectedProcForm.map((item) => item.pbSupCode)
      );
      return uniqueSupCodes.size === 1;
    },

    // 選択されたデータ処理
    selectDataProcess(data) {
      this.selectedProcForm = data;
      for (let index = 0; index < this.selectedProcForm.length; index++) {
        const element = this.selectedProcForm[index];

        if (!!element.pbSupCode) {
          // 仕入先
          element.pbSupCode = element.pbSupCode.split(":")[0];
        }
      }

      return data;
    },

    //セルの配置
    TableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;
    },
    handleRowClick(row) {
      this.currentCell = row;
    },

    // ダイアログを閉じる
    Close() {
      this.$emit("cancel");
    },

    // ダイアログを閉じる
    // onCancel() {
    //   if (
    //     !cmpDetailData(
    //       this.cmpDetailResult,
    //       this.$refs.jpRevSelectTable.selection
    //     )
    //   ) {
    //     return new Promise((resolve, reject) => {
    //       Modal.showWarning(
    //         "",
    //         t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
    //         {
    //           $type: "prompt",
    //           confirmButtonText: t("resource.button.sure"),
    //           cancelButtonText: t("resource.button.cancel"),
    //           showCancelButton: true,
    //         }
    //       )
    //         .then(() => {
    //           // 用户点击确认
    //           resolve(true);
    //         })
    //         .catch((error) => {
    //           // 用户点击取消或关闭对话框
    //           resolve(false);
    //         });
    //     });
    //   } else {
    //     return true;
    //   }
    // },

    // 列幅に自動調整
    FlexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.jpRevSelectTable);
    },
  },
};
</script>
<style scoped>
</style>
